// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// ⚠️ Use YOUR values here (yours were these):
const supabaseUrl = 'https://jktnsuwwkpcapmkbaefg.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImprdG5zdXd3a3BjYXBta2JhZWZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ0ODk2MzMsImV4cCI6MjA3MDA2NTYzM30.442lEAu8DcKYpK4zq9vayZgZtuyMRvm65WDYN4SRntM';

// Important: always https, no trailing slash, real anon key (not service role)
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'milestones.auth', // unique key
  },
});
